// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SurveyStartSessionRequestModel {
    static getAttributeTypeMap() {
        return SurveyStartSessionRequestModel.attributeTypeMap;
    }
}
SurveyStartSessionRequestModel.discriminator = undefined;
SurveyStartSessionRequestModel.additionalProperties = false;
SurveyStartSessionRequestModel.attributeTypeMap = [
    {
        "name": "surveyId",
        "baseName": "surveyId",
        "type": "number"
    },
    {
        "name": "surveySourceId",
        "baseName": "surveySourceId",
        "type": "number"
    },
    {
        "name": "sourceSystemId",
        "baseName": "sourceSystemId",
        "type": "number"
    },
];
//# sourceMappingURL=surveyStartSessionRequestModel.js.map